// extracted by mini-css-extract-plugin
export default {"submitButton":"styles_submitButton__s99PD","button":"styles_button__1-GuX"};